<script>
  import { getPath } from '../../utils/imageKit.ts';
  
  let {
    logo,
    label,
    memberIdLabel,
    pcnLabel,
    binLabel,
    groupLabel,
    translateUp = true,
    dataTestId = 'savings-card-skeleton-tile',
  } = $props();

  // Handle Image Setup
  const defaultSrc = getPath(logo, { w: 148 });
  const highResSrc = getPath(logo, { w: 148 }, 2);
</script>

<div
  data-testid={dataTestId}
  class="rounded-lg bg-white p-6 pb-4 shadow-y-md mx-auto lg:ml-0 lg:mr-auto lg:mb-0 max-w-106 print:max-w-106"
  class:-mb-25={translateUp}
>
  <div class="sm:flex justify-between items-center border-b border-gray-silver pb-4 mb-4 sm:mb-6">
    {#if logo && logo.url && logo.alt}
      <img
        src={defaultSrc}
        alt={logo.alt}
        class="max-w-32 mr-4"
        itemprop="image"
        srcet={`${defaultSrc}, ${highResSrc} 2x`}
        sizes="148px"
        width="148"
        height="28"
      />
      <span class="text-gray-charcoal text-xs leading-relaxed tracking-widest mt-3" itemprop="programName">
        <span class="visually-hidden">Inside Rx</span>
        {label}
      </span>
    {/if}
  </div>
  <div>
    <div class="text-xs leading-tight text-gray-brownish">{memberIdLabel}</div>
    <div class="w-48 h-5 mt-1 skeleton-gradient animated-skeleton"></div>
    <div class="flex flex-wrap items-center mt-5 sm:mt-8 justify-between">
      <div class="mb-4">
        <div class="text-xs leading-tight text-gray-brownish">{pcnLabel}</div>
        <div class="w-16 h-5 mt-1 skeleton-gradient animated-skeleton"></div>
      </div>
      <div class="mx-4 mb-4">
        <div class="text-xs leading-tight text-gray-brownish">{binLabel}</div>
        <div class="w-20 h-5 mt-1 skeleton-gradient animated-skeleton animation-delay-75"></div>
      </div>
      <div class="mb-4">
        <div class="text-xs leading-tight text-gray-brownish">{groupLabel}</div>
        <div class="w-25 h-5 mt-1 skeleton-gradient animated-skeleton animation-delay-100"></div>
      </div>
    </div>
  </div>
</div>
